"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.assertIsWebSocket = void 0;

function assertIsWebSocket(webSocketInstance) {
  if (webSocketInstance instanceof WebSocket === false) throw new Error('');
}

exports.assertIsWebSocket = assertIsWebSocket;
;